import api from '../../api'

export type CrewMember = {
  id: number
  name: string
  email: string | undefined | null
  userEmail: string | undefined | null
  isActive: boolean
  timesheetNotifications: boolean
  qboId: string | undefined | null
  qboDisplayName: string | undefined | null
}

export const getCrewMembers = async (): Promise<CrewMember[]> => {
  const response = await api.get<CrewMember[]>('/setup/crew')
  return response.data
}

export const updateCrewMember = async (crewMember: CrewMember): Promise<CrewMember> => {
  const response = await api.post<CrewMember>(`/web/crew-members`, crewMember)
  return response.data
}

export type QboEmployee = {
  id: string
  displayName: string
}

export const getQboEmployees = async (): Promise<QboEmployee[]> => {
  const response = await api.get<QboEmployee[]>('/quickbooks/employees?disableCache=true')
  return response.data
}
